import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { CustomButton } from '../../../../v2/MUI_custom_component';
import CardHeader from '../../Common/CardHeader';
import { cardStyles, PROFILER_IMAGES } from '../../Common/constants';
import { ProfilerQuestionID } from '../../config/QuestionEnum';
import { IndustryEnum } from '../../config/Profiler_enum';

const INDUSTRY_OPTIONS = [
  {
    label: 'Building Construction Material',
    helperText: '(BCM)',
    value: IndustryEnum.BCM,
    image: PROFILER_IMAGES.bcm,
  },
  {
    label: 'Fast Moving Consumer Goods',
    helperText: '(FMCG)',
    value: IndustryEnum.FMCG,
    image: PROFILER_IMAGES.fmcg,
  },
];

const Industry = ({
  questionId = ProfilerQuestionID.INDUSTRY,
  title = 'Which industry you work in?',
  header,
  value,
  defaultValue = '',
  onChange,
  onSubmit,
  submitLabel = 'Submit',
  width,
  maxWidth = { xs: 250, md: 300 },
}) => {
  const isControlled = typeof value === 'string';
  const [internalValue, setInternalValue] = useState(defaultValue);
  const selectedValue = isControlled ? value : internalValue;

  const handleSelect = (nextValue) => {
    if (!isControlled) {
      setInternalValue(nextValue);
    }
    onChange?.(nextValue);
  };

  const handleSubmit = () => {
    onSubmit?.({
      question: [
        { id: questionId, value: selectedValue }
      ]
    });
  };

  return (
    <Box sx={cardStyles({ width: '100%', maxWidth: maxWidth })}>
      <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, justifyContent: 'space-between', gap: 1 }}>
        {header && <Typography variant="h2">{header}</Typography>}
        <CardHeader title={title} />
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {INDUSTRY_OPTIONS.map((option) => {
            const isSelected = selectedValue === option.value;
            return (
              <Box
                key={option.value}
                onClick={() => handleSelect(option.value)}
                sx={{
                  cursor: 'pointer',
                  borderRadius: 2,
                  border: isSelected ? '2px solid #995A00' : '1px solid #995A00',
                  backgroundColor: isSelected ? '#995A001F' : '#FFFFFF',
                  px: 1,
                  py: 0.25,
                  minHeight: 112,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  
                }}
              >
                <Box component='img' alt={option.label} width={64} height={64} src={option.image} />
                <Typography variant='labelM' sx={{ color: '#333333', textAlign: 'center' }}>
                  {option.label}
                </Typography>
                <Typography variant='labelM' sx={{ color: '#333333', textAlign: 'center' }}>
                  {option.helperText}
                </Typography>
              </Box>
            );
          })}
        </Box>

        <CustomButton
          label={submitLabel}
          onClick={handleSubmit}
          disabled={!selectedValue}
          size='small'
          sx={{ width: '100%'}}
        />
      </Box>
    </Box>
  );
};

export default Industry;
